import script from "./Mantenciones_Revisiones_Pendientes_Historico.vue?vue&type=script&setup=true&lang=js"
export * from "./Mantenciones_Revisiones_Pendientes_Historico.vue?vue&type=script&setup=true&lang=js"

import "./Mantenciones_Revisiones_Pendientes_Historico.vue?vue&type=style&index=0&id=34bd6252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34bd6252"]])

export default __exports__